import React from "react";
import { translate } from '../Services/translation';
import { culture } from '../Services/culture';
import { currency } from '../Services/currency';
import formatCurrencyService from "../Services/formatCurrencyService";

const YourSelections = ({ sections, fromCart = false, onQuantityChange }) => {
    return <div>
        <div className="bundle-section">
            <div className={"your-selection__selected-options " + (fromCart ? "white-backround" : "")}>
                <ul>
                    {fromCart ? renderYourSelectionFromCart(sections, onQuantityChange) : renderYourSelection(sections)}
                </ul>
            </div>
        </div>

    </div>
}
const renderYourSelectionFromCart = (selections, onQuantityChange) => {
    return <div>
        {selections.map((variant, vIndex) => {
            const comments = JSON.parse(variant.comments);
            return <li key={variant.rowSystemId}>
                <div>
                    <div className="bundle-section_inline">
                        <div className="product-selector_image">
                            <a href={variant.url}>
                                <img className="cart-item__thumb" src={variant.image} />
                            </a>
                        </div>
                        <div className="your-selection">

                            <div className="your-selection__quantity">{variant.quantity} st</div>
                            <div className="your-selection__name">{variant.name}</div>
                            {variant.superBuilderVariantMeasurement &&
                                <div className="configurator-variants__measurement">{variant.superBuilderVariantMeasurement}</div>
                            }
                            {/* <div className="your-selection__dimensions">{variant.articleNumber}</div> */}

                        </div>
                        {!comments.IsMaximumOfOneAllowed && <div className="cart-item_section cart-change-quantity super-cart-change-quantity">
                            <a className="cart-change-quantity__minus super-quantity-sign" onClick={() => onQuantityChange(variant.articleNumber, variant.quantity - (variant.packagingQuantity > 0 ? variant.packagingQuantity : 1), variant.quantity, JSON.parse(variant.comments))}>
                                <svg>
                                    <use href="/ui/images/tibergs-svg/sprite/sprite.svg#minus"></use>
                                </svg>
                            </a>
                            <span className="cart-change-quantity__display super-quantity-count">{variant.quantity}</span>
                            <a className="cart-change-quantity__plus super-quantity-sign" onClick={() => onQuantityChange(variant.articleNumber, variant.quantity +
                                (variant.packagingQuantity > 0 ? variant.packagingQuantity : 1), variant.quantity, JSON.parse(variant.comments))}>
                                <svg>
                                    <use href="/ui/images/tibergs-svg/sprite/sprite.svg#plus"></use>
                                </svg>
                            </a>
                        </div>}
                        <div className="configurator-variants__price-container">
                            {variant.campaignPrice ? (
                                <div>
                                    <div className="configurator-variants__original-price">{variant.totalOrdinaryPrice}</div>
                                    <div className="configurator-variants__price">{variant.totalPrice}</div>
                                </div>
                            ) : (
                                <div>
                                    <span className="configurator-variants__price">{variant.totalPrice}</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </li>
        })}
    </div>
}

const renderYourSelection = (sections) => {
    {
        let formatter = new Intl.NumberFormat(culture, {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
        return <div>
            {sections.map((section, index) => (
                section.variants.map((variant, vIndex) => {
                    if (variant.selected) {
                        return <li key={vIndex}>
                            <div>
                                <div className="bundle-section_inline">
                                    <div className="product-selector_image">
                                        <a href={variant.url}>
                                            <img className="cart-item__thumb" src={variant.imageData.thumbnail} />
                                        </a>
                                    </div>
                                    <div className="your-selection">

                                        <div className="your-selection__quantity">{variant.quantity} st</div>
                                        <div className="your-selection__name">{variant.name}</div>
                                        {variant.superBuilderVariantMeasurement &&
                                            <div className="configurator-variants__measurement">{variant.superBuilderVariantMeasurement}</div>
                                        }
                                        {/* <div className="your-selection__dimensions">{variant.articleNumber}</div> */}

                                    </div>
                                    <div className="configurator-variants__price-container">
                                        {variant.campaignPrice && !isNaN(variant.SuperBuilderCampaignPrice * variant.quantity) ? (
                                            <div>                                                              
                                                <div className="configurator-variants__original-price">{formatCurrencyService.formatCurrency(formatter, variant.SuperBuilderCampaignPrice * variant.quantity)}</div>
                                                <div className="configurator-variants__price">{formatCurrencyService.formatCurrency(formatter, variant.SuperBuilderPrice * variant.quantity)}</div>
                                            </div>
                                        ) : (
                                            <div>
                                                <span className="configurator-variants__price">{formatCurrencyService.formatCurrency(formatter, variant.SuperBuilderPrice * variant.quantity)}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </li>
                    }
                })
            ))}
        </div>
    }
}

export default YourSelections;